import { Component } from '@angular/core';
import { Store } from '@ngxs/store';
import { ISmallBrickComponent } from 'src/app/components/dashboard/brick-settings/brick-specific-type-settings/ISpecificBrickSettingsComponent';
import { PresenceDurationBrickBaseComponent } from './presence-duration-brick.base.component';

@Component({
   selector: 'samweb-presence-duration-brick',
   templateUrl: './presence-duration-brick.default.component.html',
   styleUrls: ['./presence-duration-brick.small.component.scss'],
})
export class PresenceDurationBrickSmallComponent extends PresenceDurationBrickBaseComponent implements ISmallBrickComponent {
   constructor(store: Store) {
      super(store);
   }

   isSmallView = true;
}
